import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import { assignmentService, authService } from '../services/api';

export default function ReviewerAssignments() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [submission, setSubmission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expired, setExpired] = useState(false);
  useEffect(() => {
    let active = true; setLoading(true); setSubmission(null); setError('');
    const request = id ? assignmentService.submission(id) : assignmentService.mine();
    request.then(({ data }) => { if (active) { if (id) setSubmission(data); else setItems(data); } })
      .catch(error => {
        if (!active) return;
        if (error.response?.status === 401) setExpired(true);
        else setError(error.response?.status === 404 ? 'این تخصیص در دسترس شما نیست یا دیگر فعال نیست.' : 'دریافت اطلاعات ناموفق بود. صفحه را تازه‌سازی کنید.');
      }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [id]);
  if (expired) return <Navigate to="/admin-login" state={{ from: '/reviewer/assignments' }} replace />;
  const logout = async () => { await authService.logout(); navigate('/admin-login'); };
  return <div dir="rtl" className="bg-gray-100 min-h-screen p-4 sm:p-8"><div className="max-w-4xl mx-auto space-y-5">
    <div className="flex justify-between gap-4"><h1 className="text-2xl font-bold">مقالات تخصیص‌یافته به من</h1><button className="text-blue-700" onClick={logout}>خروج</button></div>
    {id && <Link className="text-blue-700 block" to="/reviewer/assignments">بازگشت به فهرست</Link>}
    {error && <p role="alert" className="text-red-800 bg-white p-4">{error}</p>}
    {loading && <p role="status">در حال دریافت اطلاعات…</p>}
    {!loading && !id && items.length === 0 && !error && <p>تخصیص فعالی برای شما وجود ندارد.</p>}
    {!loading && !id && <ul className="space-y-3">{items.map(item => <li key={item.id} className="bg-white p-4 rounded"><Link className="text-blue-700 font-bold" to={`/reviewer/assignments/${item.id}`}>{item.title}</Link><p>وضعیت: فعال</p></li>)}</ul>}
    {!loading && submission && <article className="bg-white rounded p-5 break-words space-y-4">
      <h2 className="text-xl font-bold">{submission.title}</h2>
      <h3 className="font-bold">چکیده</h3><p className="whitespace-pre-wrap">{submission.abstract}</p>
      <p>کلمات کلیدی: {submission.keywords}</p>
      <h3 className="font-bold">متن مقاله</h3><div className="whitespace-pre-wrap">{submission.content}</div>
    </article>}
  </div></div>;
}
